import { gql } from '@apollo/client';
import { ErrorMessageInfo, OrderInfoShared } from '@retainerclub/shared-api';

export default gql`
  mutation actionConvertOrderToCourtesy($input: ConvertOrderToCourtesyActionInput!) {
    actionConvertOrderToCourtesy(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      previewData
      order {
        ...OrderInfoShared
      }
    }
  }
  ${ErrorMessageInfo}
  ${OrderInfoShared}
`;
